import React from 'react';

// atoms
import Card from '../../atoms/card';
import BadgeAppStore from '../../atoms/icons/badgeAppStore';
import BadgeGooglePlay from '../../atoms/icons/badgeGooglePlay';

import './style.scss';

const StoreBadges = () => {
  return (
    <Card className="store-badges-list">
      <BadgeAppStore />
      <BadgeGooglePlay />
    </Card>
  );
};

export default StoreBadges;
